// extracted by mini-css-extract-plugin
module.exports = {"chevronLink":"ChevronLink_chevronLink__iVybl","lastWord":"ChevronLink_lastWord__SFSwd"};